import React, { useState } from 'react'
import TaskAssigneeSuperSearch from 'NewComponents/UtilityComponents/TaskAssigneeSuperSearch/TaskAssigneeSuperSearch'
import { toast } from 'react-toastify';

const TaskAssigneeBox = ({ allAssignees, handleChangeAssignee }) => {
    const [superSearchValue, setsuperSearchValue] = useState("");
    const handleSelectedAssignee = (selectedAssignee) => {
        if (selectedAssignee) {
            const isAssigneeExist = allAssignees.some((assignee) => assignee.userId === selectedAssignee.value)
            if (isAssigneeExist) {
                toast.info("Assignee already selected")
            }
            else {
                const obj = {
                    "addedBy": "",
                    "inActive": false,
                    "taskId": 0,
                    "userId": selectedAssignee.value,
                    userName: selectedAssignee.label,
                    colorCode: selectedAssignee.colorCode
                }
                const newAssignee = [...allAssignees, obj]
                handleChangeAssignee(newAssignee)
            }

        } else {

        }
        setsuperSearchValue("")
    }
    const handleRemoveAssignee = (assignee) => {
        const updatedAssignees = allAssignees.filter((al) => al.userId !== assignee.userId)
        handleChangeAssignee(updatedAssignees)
    }

    return (
        <div>
            <label className='mb-2 text-base font-semibold required'>Assignee</label>
            <div className="flex flex-wrap gap-4 ">
                <div className='w-full'>
                    <TaskAssigneeSuperSearch
                        searchValue={superSearchValue}
                        onChange={(value) => setsuperSearchValue(value)}
                        handleSelectedData={handleSelectedAssignee}
                    />
                </div>
                {allAssignees?.map((assignee, index) => (
                    <span className={`flex rounded-md font-semibold items-center p-2 py-1.5  text-sm bg-[#F8FAFB] `}>
                        {assignee.userName}  <img onClick={() => handleRemoveAssignee(assignee)} className={`ml-4 cursor-pointer  `} src=' /img/roundcross.svg' alt='cross' />
                    </span>
                ))}
            </div>
            {allAssignees.length > 15 ? <span className='float-right px-3 text-sm font-semibold text-right cursor-pointer hover:text-secondary text-secondaryLight hover:underline'>View All</span> : null}
        </div>
    )
}

export default TaskAssigneeBox